module.exports = __webpack_public_path__ + "img/1e92f8b.png";